import { render, staticRenderFns } from "./Integrations.vue?vue&type=template&id=0b1d6b70"
import script from "./Integrations.vue?vue&type=script&lang=js"
export * from "./Integrations.vue?vue&type=script&lang=js"
import style0 from "./Integrations.vue?vue&type=style&index=0&id=0b1d6b70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports